import { AiProcessingValue } from '@g17eco/types/ai';
import type {
  InitiativeUniversalTracker,
  MergedValueListOption,
  ValueListConfig,
} from '@g17eco/types/initiativeUniversalTracker';
import type { ValueValidation } from '@g17eco/types/universalTracker';

export const isExcludedFromAiProcessing = (
  initiativeUtr: Pick<InitiativeUniversalTracker, 'aiProcessing'> | undefined,
) => {
  return initiativeUtr?.aiProcessing === AiProcessingValue.Exclude;
};

export const overrideValueList = ({
  valueValidation,
  valueListConfig,
}: {
  valueValidation: ValueValidation | undefined;
  valueListConfig: ValueListConfig<MergedValueListOption> | undefined;
}) => {
  if (!valueValidation || !valueListConfig) {
    return valueValidation;
  }

  // Override regular value list options
  if (valueListConfig.options && valueValidation.valueList) {
    return {
      ...valueValidation,
      valueList: {
        ...valueValidation.valueList,
        list: valueListConfig.options,
      },
    };
  }

  // Override table column options
  if (valueListConfig.table?.columns && valueValidation.table?.columns) {
    const mergedColumns = valueValidation.table.columns.map((col) => {
      const overrideColumn = valueListConfig.table?.columns.find((c) => c.code === col.code);
      if (overrideColumn?.options) {
        return { ...col, options: overrideColumn.options };
      }
      return col;
    });

    return {
      ...valueValidation,
      table: {
        ...valueValidation.table,
        columns: mergedColumns,
      },
    };
  }

  return valueValidation;
};
